export default "__VITE_ASSET__05f1063e__"